import {api,login} from "@/configs/api";

class AuthService {
    async login(user) {
        try {
            const response = await login.post('/login', {
                email: user.email,
                password: user.password,
            });

            const { data } = response.data;
            if (!data?.token) throw new Error("Token não recebido");

            return {
                token: data.token,
                user: data,
                tipoUsuario: data.tipoUsuario,
                expiresAt: new Date(Date.now() + data.token_expiration_minutes * 60000),
                token_expire: new Date((new Date()).getTime() + (response.data.data.token_expiration_minutes * 60000)),
            };
        } catch (err) {
            throw new Error(err.response?.data?.message || "Erro no login");
        }
    }

    logout() {
        const token = localStorage.getItem('token');

        localStorage.removeItem('user');
        localStorage.removeItem('token');
        localStorage.removeItem('expiresAt');
        localStorage.removeItem('token_expire');
        if (token && token !== null) {
            login.delete('/v1/logout', {
                headers: {
                    'Content-type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': `Bearer ${token}`
                }
            }).then(response => {
                return response.data;
            });
        }
        return true;
    }

    register(user) {
        return login.post('', {
            username: user.username,
            email: user.email,
            password: user.password,
            token: user.token
        });
    }

    recoverPassowrd(user) {
        return login
            .post('/forgot', {
                email: user.email
            })
            .then(response => {
                return response.data;
            });
    }

    reset(user) {
        return login
            .post('/reset', {
                email: user.email,
                password: user.novasenha,
                password_confirmation: user.confirmasenha,
                token: user.token
            })
            .then(response => {
                return response.data;
            });
    }

    change(params) {
        return api
            .post('/change', {
            email:params.email,
            password:params.password,
            password_confirmation:params.password_confirmation
        })
            .then(response => {
            return response.data;
        });
    }
}

export default new AuthService();